import Navbar from '../../navbar/Navbar'
import Footer from '../../footer/Footer';
import DepartmentTab from '../mainTags/CSEDepartmentTab';

const CSEMentoring = () => {
  return (
    <div>
      <Navbar />
      <div className="graduate-admission pt-lg-5 pt-4 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
              <DepartmentTab />
            </div>
            <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
              <div className="how-to-apply">
                <h2>CSE Mentoring
                </h2>
                <div className=''>
                  <div class="detgails-right-content mt-1">
                    <div class="related-download bg-gray">
                      <ul>
                        <li>
                          <a href="https://admin.swec.ac.in/assetsswec/documents/cse/Mentoring-2024-25.pdf" target='_blank'><i class="fa-solid fa-file-pdf"></i>  Mentoring 2024-25</a>
                        </li>
                        <li>
                          <a href="https://admin.swec.ac.in/assetsswec/documents/cse/Mentoring-2023-24.pdf" target='_blank'><i class="fa-solid fa-file-pdf"></i>  Mentoring 2023-24</a>
                        </li>
                        <li>
                          <a href="https://admin.swec.ac.in/assetsswec/documents/cse/Mentoring-2022-23.pdf" target='_blank'><i class="fa-solid fa-file-pdf"></i>  Mentoring 2022-23</a>
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default CSEMentoring
